import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
    const { lastEvent, placesByEvent, userNameAck } = useReportFiltersFetch({
        fetchLastEvent: true,
        fetchPlacesByEvent: true,
        fetchUserNameAck: true, });

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className="space-y-4">
                    <InputDateTime
                        id="dtStart"
                        label="Data/hora inicial *"
                        selected={filters.dtStart}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label="Data/hora final *"
                        selected={filters.dtEnd}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <SelectComponent
                        label='Tipo'
                        isMulti={true}
                        wrapValues={true}
                        options={lastEvent}
                        value={filters.reportcode}
                        onChange={(value) => setFilters(prev => ({...prev, reportcode: value}))}
                        instanceId="reportcode"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Logradouro'
                        isMulti={true}
                        wrapValues={true}
                        options={placesByEvent}
                        value={filters.street}
                        onChange={(value) => setFilters(prev => ({...prev, street: value}))}
                        instanceId="street"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Encerrado por'
                        isMulti={true}
                        wrapValues={true}
                        options={userNameAck}
                        value={filters.username_ack}
                        onChange={(value) => setFilters(prev => ({...prev, username_ack: value}))}
                        instanceId="username_ack"
                        classNameWrapper={"w-full"}
                    />

                    <InputForm
                        label="Descrição"
                        value={filters.description}
                        onChange={({target}) => setFilters(prev => ({ ...prev, description: target.value }))}
                        instanceId="description"
                        id="description"
                        classNameWrapper={"w-full"}
                        autocomplete={'off'}
                    />

                    <InputForm
                        label="Conta"
                        value={filters.account}
                        onChange={({target}) => setFilters(prev => ({ ...prev, account: target.value }))}
                        instanceId="account"
                        id="account"
                        classNameWrapper={"w-full"}
                        autocomplete={'off'}
                    />
                </form>
            </div>
        </>
    );
};

export default Filters;